var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-navbar', {
    staticClass: "addBackground",
    attrs: {
      "toggleable": "lg",
      "fixed": "top",
      "type": "dark"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse",
      "id": "special"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  })])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/",
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("HOME "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/about"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("ABOUT ME "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/albums"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("ALBUMS "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/service"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("MY SERVICES "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/master"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("MASTERPIECES "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/contact"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("CONTACT "), _c('div')])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcb6112c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 4sbW
// module chunks = 0